import React from "react";

function Dictionnaire() {
  return (
    <main style={{ padding: "2rem" }}>
      <h1>Dictionnaire</h1>
      <p>Page du dictionnaire à compléter.</p>
    </main>
  );
}

export default Dictionnaire;